import { all, fork, put, takeLatest } from 'redux-saga/effects';
import {
    REQUEST_CREATE_REWARD_ITEM,
    REQUEST_CREATE_REWARD_ITEM_SUCCESS,
    REQUEST_CREATE_REWARD_ITEM_FAILURE,

} from '.';
import { showToastAlert } from '../app';
import { fetchUserInfo } from '../auth';
import { ROUTE_TRANSACTION_MANAGEMENT, goToPage } from '../routing';


function* handleCreateClue() {
    yield takeLatest([REQUEST_CREATE_REWARD_ITEM], function* () {
        yield put(showToastAlert('Creating Reward item...'));
    });

    yield takeLatest([REQUEST_CREATE_REWARD_ITEM_SUCCESS], function* () {
        yield put(showToastAlert('Reward item created successfully!', 'success'));
        yield put(fetchUserInfo());
        yield put(goToPage(ROUTE_TRANSACTION_MANAGEMENT));
    });

    yield takeLatest([REQUEST_CREATE_REWARD_ITEM_FAILURE], function* (action) {
        yield put(showToastAlert(action?.payload?.error?.message || 'Failed to create reward item!', 'error'));
    });
}

export function* createRewardPage() {
    yield all([fork(handleCreateClue)]);
}

